import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=08e4c93a&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=08e4c93a&prod&lang=scss&scoped=true"
import style1 from "./EventDetail.vue?vue&type=style&index=1&id=08e4c93a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e4c93a",
  null
  
)

export default component.exports